export default "__VITE_ASSET__C8tZkKOR__"